import { isBefore, isEqual } from "date-fns";

import parseDate from "@lib/date/parseDate";
import { DATE_RANGE_PARTS_REGEX } from "@lib/regex";

const parseRange = (rangeText: string, dateTemplate: string, minDate?: Date, maxDate?: Date): [Date, Date] | null => {
  const partsMatch = rangeText.trim().match(DATE_RANGE_PARTS_REGEX);
  if (!partsMatch) {
    return null;
  }

  const fromStr = partsMatch[1];
  const toStr = partsMatch[2];

  const fromDate = parseDate(fromStr, dateTemplate, minDate, maxDate);
  const toDate = parseDate(toStr, dateTemplate, minDate, maxDate);

  if (!fromDate || !toDate || !(isBefore(fromDate, toDate) || isEqual(fromDate, toDate))) {
    return null;
  }
  return [fromDate, toDate];
};
export default parseRange;
